export enum HttpError {
  Unauthorized = 'UNAUTHORIZED',
  Forbidden = 'FORBIDDEN',
  FileNotFound = 'MISSING',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
}
